/* eslint-disable react-hooks/rules-of-hooks */
import React, { useState, useRef, useEffect } from "react";
import { LinkContainer } from "react-router-bootstrap";
import { connect } from "react-redux";
import {
  REMOVE_CARGO,
  SHIPMENT_TRACKING_NUMBER,
  SUCCESS,
  CARGO_TRACKING_NUMBER,
  ERROR,
  ERROR_TYPE,
} from "../../../constants/mixpanelConstants";
import { getMixpanelData, mixPanelTrack } from "../../../utils/mixpanelUtils";
import { shipmentActions } from "../../../actions/rootActions";
import NotificationArea from "./notificationArea";

const removeCargoFromShipmentPage = (props) => {
  const shipment = props.location.state.shipment;

  const trackingNoInputRef = useRef(null);
  const [trackingNo, setTrackingNo] = useState("");

  const [notificationBoxType, setNotificationBoxType] = useState({
    showNoDataBox: true,
    showValidDataBox: false,
    showErrorDataBox: false,
  });

  const [successNotificationData, setSuccessNotificationData] = useState({});
  const [errorNotificationData, setErrorNotificationData] = useState({
    errorMessage: "",
  });

  const [toggleContent, setToggleContent] = useState({
    showMainContent: true,
    showSettingsContent: false,
  });

  useEffect(() => {
    if (props.removeCargoFromShipmentSuccess) {
      setNotificationBoxType({
        showNoDataBox: false,
        showValidDataBox: true,
        showErrorDataBox: false,
      });
      setSuccessNotificationData({
        tracking_no: trackingNo,
        successMessage: "Successfully Removed!",
      });
      setTrackingNo("");
      playSound("success");
      // mixpanel track removing cargo from shipment
      const mixPanelData = getMixpanelData();
      mixPanelTrack(REMOVE_CARGO, {
        [SUCCESS]: true,
        ...mixPanelData,
        [SHIPMENT_TRACKING_NUMBER]: shipment.tracking_no,
        [CARGO_TRACKING_NUMBER]: trackingNo,
      });
    }
  }, [props.removeCargoFromShipmentSuccess]);

  useEffect(() => {
    if (props.removeCargoFromShipmentError) {
      setNotificationBoxType({
        showNoDataBox: false,
        showValidDataBox: false,
        showErrorDataBox: true,
      });
      setErrorNotificationData({
        errorMessage: props.removeCargoFromShipmentError.errorData,
        jsonBody: props.removeCargoFromShipmentError.jsonBody,
      });
      setTrackingNo("");
      playSound("error");
      const mixPanelData = getMixpanelData();
      mixPanelTrack(REMOVE_CARGO, {
        [ERROR_TYPE]: REMOVE_CARGO,
        [SUCCESS]: false,
        [ERROR]: props.removeCargoFromShipmentError,
        ...mixPanelData,
        [SHIPMENT_TRACKING_NUMBER]: shipment.tracking_no,
        [CARGO_TRACKING_NUMBER]: trackingNo,
      });
    }
  }, [props.removeCargoFromShipmentError]);

  useEffect(() => {
    return () => {
      props.dispatch(shipmentActions.clearRemoveCargoFromShipmentData());
    };
  }, []);

  return (
    <div className="scanner-bg-container">
      <div className="d-flex ml-sm-0 ml-3 bread-crumb-container">
        <LinkContainer to="/scan/hubmanage/shipments">
          <p className="link-title mb-0">Shipments</p>
        </LinkContainer>
        <p className="bread-crumb mt-n1 mb-0">{">"}</p>
        <p className="link-title text-capitalize mb-0" onClick={onCargoClick}>
          {shipment.tracking_no}
        </p>
        <p className="bread-crumb mt-n1 mb-0">{">"}</p>
        <p className="title text-capitalize mb-0">Remove Parcel/Cargo</p>
      </div>
      {toggleContent.showMainContent && mainContent()}
    </div>
  );

  function onCargoClick() {
    goBackToPreviousScreen();
  }

  function mainContent() {
    return (
      <div className="row">
        <div className="col-md-6 col-sm-12">{notificationAndScanInputField()}</div>
      </div>
    );
  }

  function notificationAndScanInputField() {
    const noDataBoxClass = notificationBoxType.showNoDataBox ? "d-flex" : "d-none";
    const errorDataBoxClass = notificationBoxType.showErrorDataBox ? "d-flex flex-column" : "d-none";
    const validDataBoxClass = notificationBoxType.showValidDataBox ? "d-flex flex-column" : "d-none";
    return (
      <NotificationArea
        shipment={shipment}
        trackingNoInputRef={trackingNoInputRef}
        trackingNo={trackingNo}
        setTrackingNo={setTrackingNo}
        notificationBoxType={notificationBoxType}
        noDataBoxClass={noDataBoxClass}
        errorDataBoxClass={errorDataBoxClass}
        validDataBoxClass={validDataBoxClass}
        successNotificationData={successNotificationData}
        errorNotificationData={errorNotificationData}
        onPressEnter={onRemoveCargoFromShipment}
        onChangeScanNumberCameraChange={onChangeScanNumberCameraChange}
      />
    );
  }

  function onRemoveCargoFromShipment(scannedTrackingNo) {
    const trackingCodeToSend = scannedTrackingNo ? scannedTrackingNo : trackingNo;
    const data = {
      hub_id: localStorage.getItem("hubId"),
      hubscanner_key: localStorage.getItem("userId"),
      shipment_no: shipment.tracking_no.trim(),
      scanned_tracking_no: trackingCodeToSend.trim(),
    };
    props.dispatch(shipmentActions.removeCargoFromShipment(data));
  }

  function onChangeScanNumberCameraChange(scanResult) {
    const scannedNumber = scanResult.text;
    setTrackingNo(scannedNumber);
    onRemoveCargoFromShipment(scannedNumber);
  }

  function playSound(type) {
    const sounds = {
      success: new Audio("/sounds/success.mp3"),
      error: new Audio("/sounds/error.mp3"),
    };
    sounds[type].play();
  }

  function goBackToPreviousScreen() {
    props.history.goBack();
  }
};

const mapStateToProps = (state) => ({
  removeCargoFromShipmentSuccess: state.shipment.removeCargoFromShipmentSuccess,
  removeCargoFromShipmentError: state.shipment.removeCargoFromShipmentError,
});

export default connect(mapStateToProps)(removeCargoFromShipmentPage);
